var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Detil Pengajuan"
    }
  }, [(!_vm.DataHeader || !_vm.listdokap) ? _c('div', {
    staticClass: "d-flex align-items-center justify-content-center",
    staticStyle: {
      "height": "20rem"
    }
  }, [_c('half-circle-spinner', {
    attrs: {
      "animation-duration": 1000,
      "size": 60,
      "color": '#000000'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.DataHeader && _vm.listdokap) ? _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(_vm.DataHeader.status === '10') ? _c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cekkirim
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("\n                  Kirim")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Data Pengajuan Izin"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v(_vm._s(_vm.DataHeader.URAIAN))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.npwp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.NM_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Alamat")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.AL_PERUSAHAAN))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No HP/Telepon")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_hp))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Email")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.email))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-12 col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Kantor")]), _vm._v(" "), _c('td', [_vm._v("020400 - KPU BC Tipe B Batam")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("No Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.no_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Tanggal Permohonan")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.tgl_mohon))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Jenis Permohonan Izin")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.DataHeader.nama_ijin))])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> Dokumen Pelengkap"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n                    Lampiran Dokumen / Data\n                    "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "title": "Tambah Dokumen/Data Pelengkap",
      "type": "button"
    },
    on: {
      "click": _vm.addModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add Dokap")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('table', {
    staticClass: "table table-bordered table-responsive table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nama Dokumen")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-sm-block"
  }, [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th', {
    staticClass: "d-none d-md-block"
  }, [_vm._v("Keterangan")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listdokap), function(dokap) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(dokap.nama_dokap))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-sm-block"
    }, [_vm._v(_vm._s(dokap.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(dokap.isian2))]), _vm._v(" "), _c('td', {
      staticClass: "d-none d-md-block"
    }, [_vm._v(_vm._s(dokap.keterangan))]), _vm._v(" "), _c('td', [(dokap.url_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": dokap.url_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.editDokap(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), (dokap.kd_dokap === 151 || dokap.kd_dokap === 256) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (dokap.kd_dokap === 145 || dokap.kd_dokap === 146) ? _c('button', {
      staticClass: "btn btn-secondary",
      attrs: {
        "title": "Edit Dokumen/Data Pelengkap",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.opendtl(dokap.id_permohonan_dokap, dokap.kd_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (dokap.fl_mandatory === null) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus Dokumen/Data Pelengkap"
      },
      on: {
        "click": function($event) {
          _vm.confir(dokap.id_permohonan_dokap)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })]) : _vm._e()])])
  }))])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('router-link', {
    staticClass: "btn btn-secondary pull-right",
    attrs: {
      "to": '/pengajuan'
    }
  }, [_c('i', {
    staticClass: "fa fa-mail-reply"
  }), _vm._v("\n                Back")])], 1)])]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Tambah Dokumen Pelengkap"
    },
    on: {
      "ok": function($event) {
        _vm.ModalDokap = false
      }
    },
    model: {
      value: (_vm.ModalDokap),
      callback: function($$v) {
        _vm.ModalDokap = $$v
      },
      expression: " ModalDokap "
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Jenis Dokumen Pelengkap"
    }
  }, [_c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "list": _vm.jndokap,
      "option-value": "kd_dokap",
      "option-text": "nama_dokap"
    },
    on: {
      "input": function($event) {
        _vm.getDtlDokap(_vm.isidokap.jndok)
      }
    },
    model: {
      value: (_vm.isidokap.jndok),
      callback: function($$v) {
        _vm.isidokap.jndok = $$v
      },
      expression: "isidokap.jndok"
    }
  })], 1), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [(_vm.field.tabel_ref === 'referensi.tr_pelln' || _vm.field.tabel_ref === 'referensi.tr_pelabuhan') ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.negara),
      expression: " isidokap.negara "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pilih Negara"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.negara = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Negara")]), _vm._v(" "), _vm._l((_vm.jnNegara), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      },
      on: {
        "click": function($event) {
          _vm.referensiDokap()
        }
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi) + "\n            ")])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tabel_ref !== null) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: " isidokap.isian1 "
    }],
    attrs: {
      "title": "Pilih Data Pelengkap",
      "lass": "form-control"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.isidokap.isian1 = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Data")]), _vm._v(" "), _vm._l((_vm.jnPelln), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.id_lokasi
      }
    }, [_vm._v(_vm._s(jn.nm_lokasi))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'date' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: " isidokap.isian1 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "date"
    },
    domProps: {
      "value": (_vm.isidokap.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'text' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian1),
      expression: " isidokap.isian1 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'number' && _vm.field.tabel_ref === null) ? _c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "separator": ".",
      "precision": 2
    },
    model: {
      value: (_vm.isidokap.isian1),
      callback: function($$v) {
        _vm.isidokap.isian1 = $$v
      },
      expression: " isidokap.isian1 "
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('This')),
      expression: " errors.has( 'This' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('This')) + "\n          ")])], 1), _vm._v(" "), (_vm.field.tipe2 === 'text') ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: " 'required|field' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian2),
      expression: " isidokap.isian2 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "Isi",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Isi')),
      expression: " errors.has( 'Isi' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Isi')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.tipe2 === 'Date') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: " 'required|field' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.isian2),
      expression: " isidokap.isian2 "
    }],
    staticClass: "form-control",
    attrs: {
      "name": "Tanggal",
      "type": "date"
    },
    domProps: {
      "value": (_vm.isidokap.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal')),
      expression: " errors.has( 'Tanggal' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Tanggal')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.expire === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Akhir Berlaku"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|field'),
      expression: " 'required|field' "
    }],
    attrs: {
      "title": "Akhir Berlaku Dokumen/Data",
      "name": "Akhir Berlaku",
      "type": "date"
    },
    model: {
      value: (_vm.edit.akhirberlaku),
      callback: function($$v) {
        _vm.edit.akhirberlaku = $$v
      },
      expression: " edit.akhirberlaku "
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Akhir Berlaku')),
      expression: " errors.has( 'Akhir Berlaku' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Akhir Berlaku')) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isidokap.keterangan),
      expression: " isidokap.keterangan "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Keterangan Terkait Dokumen/Data",
      "type": "text"
    },
    domProps: {
      "value": (_vm.isidokap.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isidokap.keterangan = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.field.fl_file === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Upload File (Max. 800 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveDokap()
      }
    }
  }, [_vm._v("Save")])], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap"
    },
    on: {
      "ok": function($event) {
        _vm.Modaledit = false
      }
    },
    model: {
      value: (_vm.Modaledit),
      callback: function($$v) {
        _vm.Modaledit = $$v
      },
      expression: " Modaledit "
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingEdit,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Edit Dokumen Pelengkap"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.jndok),
      expression: " edit.jndok "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Jenis Dokumen/Data",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.edit.jndok = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Pilih Jenis Dokumen")]), _vm._v(" "), _vm._l((_vm.jndokap), function(jn) {
    return _c('option', {
      domProps: {
        "value": jn.kd_dokap
      },
      on: {
        "click": function($event) {
          _vm.getDtlDokap(jn.kd_dokap)
        }
      }
    }, [_vm._v(_vm._s(jn.nama_dokap) + "\n            ")])
  })], 2)]), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi1
    }
  }, [(_vm.field.tabel_ref === 'referensi.tr_pelln' || _vm.field.tabel_ref === 'referensi.tr_pelabuhan') ? _c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "list": _vm.jnNegara,
      "option-value": "id_lokasi",
      "option-text": "nm_lokasi",
      "name": "Nama Negara",
      "placeholder": "-- Pilih Negara --"
    },
    on: {
      "input": function($event) {
        _vm.referensiDokap()
      }
    },
    model: {
      value: (_vm.edit.negara),
      callback: function($$v) {
        _vm.edit.negara = $$v
      },
      expression: " edit.negara "
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tabel_ref !== null) ? _c('model-list-select', {
    staticClass: "form-control",
    attrs: {
      "list": _vm.jnPelln,
      "option-value": "id_lokasi",
      "option-text": "nm_lokasi",
      "name": "Nama Pelabuhan",
      "placeholder": "-- Pilihan --"
    },
    model: {
      value: (_vm.edit.isian1),
      callback: function($$v) {
        _vm.edit.isian1 = $$v
      },
      expression: " edit.isian1 "
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'date' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: " edit.isian1 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "This",
      "type": "date"
    },
    domProps: {
      "value": (_vm.edit.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'text' && _vm.field.tabel_ref === null) ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian1),
      expression: " edit.isian1 "
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": _vm.field.maxlength,
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.isian1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian1 = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.field.tipe1 === 'number' && _vm.field.tabel_ref === null) ? _c('vue-numeric', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor/Kode Dokumen/Data",
      "name": "This",
      "separator": ".",
      "precision": 2
    },
    model: {
      value: (_vm.edit.isian1),
      callback: function($$v) {
        _vm.edit.isian1 = $$v
      },
      expression: " edit.isian1 "
    }
  }) : _vm._e(), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('This')),
      expression: " errors.has( 'This' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('This')) + "\n          ")])], 1), _vm._v(" "), (_vm.field.tipe2 === 'text') ? _c('b-form-fieldset', {
    attrs: {
      "label": _vm.field.isi2
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian2),
      expression: " edit.isian2 "
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": _vm.field.maxlength2,
      "title": "Nomor/Kode Dokumen/Data",
      "name": "Isi",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Isi')),
      expression: " errors.has( 'Isi' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Isi')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.tipe2 === 'Date') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.isian2),
      expression: " edit.isian2 "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tanggal Dokumen/Data",
      "name": "Tanggal",
      "type": "date"
    },
    domProps: {
      "value": (_vm.edit.isian2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.isian2 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Tanggal')),
      expression: " errors.has( 'Tanggal' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n            " + _vm._s(_vm.errors.first('Tanggal')) + "\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.field.expire === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "label": "Akhir Berlaku"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }],
    attrs: {
      "title": "Akhir Berlaku Dokumen/Data",
      "name": "Akhir Berlaku",
      "type": "date"
    },
    model: {
      value: (_vm.edit.akhirberlaku),
      callback: function($$v) {
        _vm.edit.akhirberlaku = $$v
      },
      expression: " edit.akhirberlaku "
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-form-fieldset', {
    attrs: {
      "label": "Keterangan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.edit.keterangan),
      expression: " edit.keterangan "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Keterangan Dokumen/Data",
      "type": "text"
    },
    domProps: {
      "value": (_vm.edit.keterangan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.edit.keterangan = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.field.fl_file === 'Y') ? _c('b-form-fieldset', {
    attrs: {
      "title": "Upload Dokumen",
      "label": "Upload File (Max. 2000 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "title": "Upload Dokumen",
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateDokap()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "no-close-on-backdrop": "",
      "size": "medium"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl),
      callback: function($$v) {
        _vm.Modaleditdtl = $$v
      },
      expression: " Modaleditdtl "
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingEdit,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingEdit = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addRow($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor Peti Kemas"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nocont),
      expression: " nocont "
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "11",
      "title": "Nomor Peti Kemas",
      "name": "petikemas",
      "required": ""
    },
    domProps: {
      "value": (_vm.nocont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nocont = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('petikemas')),
      expression: " errors.has( 'petikemas' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n              " + _vm._s(_vm.errors.first('petikemas')) + "\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Ukuran"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ukcont),
      expression: " ukcont "
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "2",
      "title": "Nomor Peti Kemas",
      "name": "ukuran",
      "required": ""
    },
    domProps: {
      "value": (_vm.ukcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ukcont = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ukuran')),
      expression: " errors.has( 'ukuran' ) "
    }],
    staticClass: "text-danger"
  }, [_vm._v("\n              Wajib diisi dan berisi angka\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "<br>"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Tambah",
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n              Tambah")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', [_c('input', {
    ref: "fileupload",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.loadCSV
    }
  }), _vm._v(" "), _c('small', [_vm._v("upload file csv (format csv menggunakan koma (,) bukan titik koma (;))")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('a', {
    attrs: {
      "href": _vm.$http.options.root + '/dllaporan/formatcont'
    }
  }, [_c('button', {
    staticClass: "btn btn-warning"
  }, [_vm._v("Download Format\n            CSV")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor Peti Kemas")]), _vm._v(" "), _c('th', [_vm._v("Ukuran")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', {
      key: peti.isian1
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.hapusrow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])])]), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn btn-danger pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.Modaleditdtl = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v("  \n      "), _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.savedokapdtl
    }
  }, [_vm._v("Simpan")])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl1 = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl1),
      callback: function($$v) {
        _vm.Modaleditdtl1 = $$v
      },
      expression: " Modaleditdtl1 "
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.nocont),
      expression: " nocont "
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Nomor",
      "name": ""
    },
    domProps: {
      "value": (_vm.nocont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nocont = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: " 'required' "
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ukcont),
      expression: " ukcont "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "title": "Nomor Peti Kemas",
      "name": ""
    },
    domProps: {
      "value": (_vm.ukcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ukcont = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Upload File (Max. 800 Kb)"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-progress-bar')], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-2"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": ""
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "title": "Tambah Dokumen",
      "type": "button"
    },
    on: {
      "click": _vm.savedokapdtl1
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Dokumen")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticStyle: {
      "height": "300px",
      "max-height": "300px",
      "overflow-y": "scroll"
    }
  }, [_c('table', {
    staticClass: "table table-responsive-sm table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("Nomor")]), _vm._v(" "), _c('th', [_vm._v("Tanggal")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(peti, index) {
    return _c('tr', {
      key: peti.isian1
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(peti.isian2))]), _vm._v(" "), _c('td', [(peti.nm_file !== null) ? _c('a', {
      staticClass: "btn btn-warning",
      attrs: {
        "title": "Download Dokumen Pelengkap",
        "href": _vm.$http.options.base + peti.url_file + '/' + peti.nm_file,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "title": "Hapus",
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.confirmdtl(peti.id_permohonan_dokap_dtl)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }))])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Edit Dokumen Pelengkap",
      "no-close-on-backdrop": "",
      "size": "lg"
    },
    on: {
      "ok": function($event) {
        _vm.Modaleditdtl2 = false
      }
    },
    model: {
      value: (_vm.Modaleditdtl2),
      callback: function($$v) {
        _vm.Modaleditdtl2 = $$v
      },
      expression: "Modaleditdtl2"
    }
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingEdit,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor PPFTZ*"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.noPpftz),
      expression: "dataNoStrip.noPpftz"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "No. PPFTZ",
      "type": "text",
      "placeholder": "No. PPFTZ"
    },
    domProps: {
      "value": (_vm.dataNoStrip.noPpftz)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.noPpftz = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal PPFTZ*"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.tglPpftz),
      expression: "dataNoStrip.tglPpftz"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tgl. PPFTZ",
      "type": "date",
      "placeholder": "Tgl. PPFTZ"
    },
    domProps: {
      "value": (_vm.dataNoStrip.tglPpftz)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.tglPpftz = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Nomor BC 1.1*"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.noBc11),
      expression: "dataNoStrip.noBc11"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "No. BC 1.1",
      "type": "text",
      "placeholder": "No. BC 1.1"
    },
    domProps: {
      "value": (_vm.dataNoStrip.noBc11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.noBc11 = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('b-form-fieldset', {
    attrs: {
      "label": "Tanggal BC 1.1*"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.tglBc11),
      expression: "dataNoStrip.tglBc11"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Tgl. BC 1.1",
      "type": "date",
      "placeholder": "Tgl. BC 1.1"
    },
    domProps: {
      "value": (_vm.dataNoStrip.tglBc11)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.tglBc11 = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.pos),
      expression: "dataNoStrip.pos"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Pos",
      "type": "text",
      "placeholder": "Pos*"
    },
    domProps: {
      "value": (_vm.dataNoStrip.pos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.pos = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.noKontainer),
      expression: "dataNoStrip.noKontainer"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "No. Kontainer",
      "type": "text",
      "placeholder": "No. Kontainer*"
    },
    domProps: {
      "value": (_vm.dataNoStrip.noKontainer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.noKontainer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataNoStrip.ukKontainer),
      expression: "dataNoStrip.ukKontainer"
    }],
    staticClass: "form-control",
    attrs: {
      "title": "Uk. Kontainer",
      "type": "text",
      "placeholder": "Uk. Kontainer*"
    },
    domProps: {
      "value": (_vm.dataNoStrip.ukKontainer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataNoStrip.ukKontainer = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.savedokapdtl2
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah")])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("No")]), _vm._v(" "), _c('th', [_vm._v("No. / Tgl. PPFTZ")]), _vm._v(" "), _c('th', [_vm._v("No. / Tgl. BC 1.1")]), _vm._v(" "), _c('th', [_vm._v("Pos")]), _vm._v(" "), _c('th', [_vm._v("No. / Uk. Kontainer")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.cont), function(item, index) {
    return _c('tr', {
      key: item.isian1
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isian1 + ' / ' + item.isian2))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isian3 + ' / ' + item.isian4))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isian5))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.isian6 + ' / ' + item.isian7 + '"LCL') + " "), _c('button', {
      staticClass: "btn btn-danger pull-right"
    }, [_c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          _vm.confirmdtl2(item.id_permohonan_dokap_dtl)
        }
      }
    })])])])
  }))])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "title": "Persetujuan"
    },
    on: {
      "ok": function($event) {
        _vm.ModalDisclaimer = false
      }
    },
    model: {
      value: (_vm.ModalDisclaimer),
      callback: function($$v) {
        _vm.ModalDisclaimer = $$v
      },
      expression: " ModalDisclaimer "
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('loading', {
    attrs: {
      "active": _vm.isLoadingKirim,
      "is-full-page": false
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingKirim = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-fieldset', [_c('b-form-checkbox', {
    attrs: {
      "value": "Y",
      "unchecked-value": ""
    },
    model: {
      value: (_vm.disclaimer),
      callback: function($$v) {
        _vm.disclaimer = $$v
      },
      expression: " disclaimer "
    }
  }, [_vm._v("\n            Saya menyatakan bahwa data yang disampaikan adalah benar\n            dan saya bertanggungjawab atas kebenaran data/dokumen yang disampaikan\n          ")]), _vm._v(" "), (_vm.disclaimer === 'Y') ? _c('div', {
    staticClass: "p-3 pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.kirim
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v(" Kirim")])]) : _vm._e()], 1)], 1)], 1)]), _vm._v(" "), _c('b-modal', {
    staticClass: "modal-danger",
    attrs: {
      "title": "Hasil Validasi",
      "ok-variant": "danger"
    },
    model: {
      value: (_vm.ModalError),
      callback: function($$v) {
        _vm.ModalError = $$v
      },
      expression: " ModalError "
    }
  }, [_c('ul', _vm._l((_vm.validasi), function(val) {
    return _c('li', {
      staticClass: "font"
    }, [_vm._v(_vm._s(val))])
  }))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a2181b4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pengajuan/DetilHeader.vue
// module id = 280
// module chunks = 0